import * as FIELD_NAME from 'constant/form-item-names'
import * as FIELD_LABEL from 'constant/form-labels'
import React from 'react'
import { Form, Switch } from 'antd'
import PropTypes from 'prop-types'

const ShowToggle = ({ show = true }) => {
  return (
    <>
      <Form.Item
        label={FIELD_LABEL.SHOW_TOGGLE}
        name={FIELD_NAME.SHOW_TOGGLE}
      >
        <Switch defaultChecked={show} />
      </Form.Item>
    </>
  )
}

ShowToggle.propTypes = {
  show: PropTypes.bool
}

export default ShowToggle
